import React from 'react'
import TBCEditorMainMenu from './TBCEditorMainMenu'
import TBCEditorFormIntro from './TBCEditorFormIntro'
import TBCEditorFormStory from './TBCEditorFormStory'
import TBCEditorFormStoryEpisode from './TBCEditorFormStoryEpisode'
import TBCEditorFormEpisodeEditor from './TBCEditorFormEpisodeEditor'
import TBCEditorFormImportJSON from './TBCEditorFormImportJSON'
import GlobalStorage from './storage/GlobalStorage'
import AppZipCreator from '../AppZipCreator'
import AppBlobCache from '../AppBlobCache'
import axios from 'axios'
import JSZip from 'jszip';

import Sortable, { MultiDrag, Swap } from 'sortablejs';

function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
};

export default class TBCEditor extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {
      name:'root'
    }
    this.TBCEditorMainMenu = React.createRef();
    this.GS = new GlobalStorage();
    /*
    this.TBCEditorMainMenu = React.createRef();

    let formData = new FormData()

    formData.append('email', "kwongsham@gmail.com");
    formData.append('password', "Tbc61369937");
    
    axios({
      method: 'post',
      url: global.CMS_URL+'admin/users/login',
      data: formData
    })
    .then(response => {
      if (global.DEBUG){
       console.log('Login Success Response:', response.data)
      }
      this.GS.setUser(response.data);      
      
    })
    .catch(error => {
      console.log(error.response.data)
      if (error.response.data.exception === 'com.gt.tbc.api.exceptions.ResourceNotFoundException') {
        console.log('Incorrect email and/or password.');
      } else {
        console.log('An error occurred. Please try again.');
      }    
    })*/
    

    
  }

  doAction(item, bundle)
  {
    if (global.DEBUG){
      console.log(item, bundle);
    }
    if (item.is_href)
    {
      this.setState({
        name: bundle.name,
        bundle: bundle,
      })
      
    }

    if (item.value === `Play`)
    { 
      if (global.DEBUG){
        console.log(new GlobalStorage().parseStoryEpisodeItemsToJsonObject());
      }
      this.props.onPlay && this.props.onPlay(new GlobalStorage().parseStoryEpisodeItemsToJsonObject());
    }

    if (item.value === 'Export')
    {      
      //new AppZipCreator().generateZipWithBlobCache(this.GS.getStoryEpisode(), this.GS.parseStoryEpisodeItemsToJsonObject(),this.GS.getStoryEpisode().project_name);
      new AppZipCreator().fulfillZipWithJSON(new JSZip(),
                                              [],
                                              new AppBlobCache().getMediaBlobs(),
                                              Object.assign({}, this.GS.getStoryEpisodeWithOutAttachment()),
                                              this.GS.getStoryEpisode().project_name);
    }

    if (item.value === 'Scenes'){
      //init sortable
      /*var el = document.getElementById('items');
      var sortable = Sortable.create(el,{
        onUpdate:function(evt){
          this.storyEpisode = new GlobalStorage().getStoryEpisode();
          array_move(this.storyEpisode.items, evt.oldIndex, evt.newIndex);                              
        }
      });*/
    }
    
    if (item.value === 'Email')
    {      
      new AppZipCreator().generateEmail(this.GS.getStoryEpisode(), this.GS.parseStoryEpisodeItemsToJsonObject());
    }
    
    if (item.value === 'CreateEpisode')
    {      
      new AppZipCreator().createEpisode();
    }
    

  }

  

  render()
  {
    return (
        <div style={{position: `relative`, height: `100%`, display: `flex`, flexDirection: `row`}}>
          <div style={{flex: `0 0 130px`, position: `relative`, height: `100%`,
            backgroundColor: '#999'}}>

            <TBCEditorMainMenu doAction={this.doAction.bind(this)} ref={this.TBCEditorMainMenu}/>

          </div>
          <div style={{flex: `0 0 500px`, position: `relative`, height: `100%`,
            backgroundColor: '#eee'}}>

            {
              this.state.name === 'StoryEpisode' ? (
                  <TBCEditorFormStoryEpisode {...this.props} doSwitch={
                      (item)=>{
                      if (item){                        
                        this.TBCEditorMainMenu.current.state.href=item;
                        this.TBCEditorMainMenu.current.forceUpdate();
                        this.state.name=item
                        this.forceUpdate()
                      }
                    } 
                  }/>
              ) : null
            }

{
              this.state.name === 'Story' ? (
                  <TBCEditorFormStory {...this.props} doSwitch={
                      (item)=>{
                      if (item){                        
                        this.TBCEditorMainMenu.current.state.href=item;
                        this.TBCEditorMainMenu.current.forceUpdate();
                        this.TBCEditorMainMenu.current.items_root.menu = [
                          {is_href: true, value: `Story`, label: `創作故事`},
                          {is_href: true, value: `StoryEpisode`, label: `創作故事章節`},
                          {is_href: true, value: `Scenes`, label: `編輯故事`},                        
                        ]
                        this.state.name=item
                        this.forceUpdate()
                      }
                    } 
                  }/>
              ) : null
            }

            {
              this.state.name === 'Scenes' ? (
                  <TBCEditorFormEpisodeEditor {...this.props}/>
              ) : null                            
            }

            {
              this.state.name === 'Import' ? (
                  <TBCEditorFormImportJSON {...this.props}/>
              ) : null
            }

{
              this.state.name === 'root' ? (
                  <TBCEditorFormIntro/>
              ) : null
            }

          </div>
        </div>
    )
  }
}